import { render } from "./RegistrierenSeite.vue?vue&type=template&id=2397c9a6"
import script from "./RegistrierenSeite.vue?vue&type=script&lang=js"
export * from "./RegistrierenSeite.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__